import React, { createContext, useContext, useEffect, useState } from "react";

// Crear el contexto
const AuthContextNOK = createContext();

// Hook para usar el contexto
export const useAuthNOK = () => useContext(AuthContextNOK);

// Provider
export const AuthProviderNOK = ({ children }) => {
  const [nokUser, setNokUser] = useState(null);

  // ✅ Cargar datos desde localStorage al iniciar
  useEffect(() => {
    const storedUser = localStorage.getItem("nokUser");
    if (storedUser) {
      setNokUser(JSON.parse(storedUser));
    }
  }, []);

  // ✅ Función para login
  const loginNOK = (userData) => {
    const formattedUser = {
      nokId: userData.nokId,
      token: userData.token,
      nameContact: userData.nameContact,
      phoneNumber: userData.phoneNumber,
      allowed: userData.allowed, // sigue como string
      contactListId: userData.contactListId,
      enableSMS: !!userData.enableSMS, // asegura booleano
      enableVoice: !!userData.enableVoice,
    };
    

    setNokUser(formattedUser);
    localStorage.setItem("nokUser", JSON.stringify(formattedUser));
  };

  // ✅ Función para logout
  const logoutNOK = () => {
    setNokUser(null);
    localStorage.removeItem("nokUser");
  };

  // ✅ Función para actualizar algunos datos (ej: tras guardar switches)
  const updateNokUser = (updatedFields) => {
    const updatedUser = { ...nokUser, ...updatedFields };
    setNokUser(updatedUser);
    localStorage.setItem("nokUser", JSON.stringify(updatedUser));
  };

  return (
    <AuthContextNOK.Provider
      value={{
        nokUser,
        loginNOK,
        logoutNOK,
        updateNokUser,
      }}
    >
      {children}
    </AuthContextNOK.Provider>
  );
};
